import React from 'react';

const useUnderlayClassname = (
  className?: string,
  centered?: boolean,
  isSecure?: boolean
): string => {
  return React.useMemo<string>(() => {
    return ['fixed top-0 left-0 bottom-0 right-0 outline-none overflow-auto items-start']
      .addNotEmpty(className)
      .addIf(isSecure, 'backdrop-blur backdrop-grayscale-[.8] z-[200000]', 'z-[1400]')
      .addIf(centered, 'items-center')
      .toClassNames();
  }, [centered, className, isSecure]);
};

export default useUnderlayClassname;
